import { Button, InfoPage, SpinnerCenter } from "@shapr3d/frontend-lib";
import type { MutationStatus } from "@tanstack/react-query";

import useNavigation from "../../hooks/navigation";
import { UserError } from "../../hooks/useAccountTypes";
import useTranslation from "../../hooks/useTranslation";

interface ConfirmEmailChangeProps {
  requestNewChange: () => void;
  state: MutationStatus;
  isLoggedIn: boolean;
  requestError?: UserError;
  newEmail?: string;
}

const ConfirmEmailChange = (props: ConfirmEmailChangeProps) => {
  const { t, m } = useTranslation();
  const navigation = useNavigation();

  const displayedError =
    props.requestError === UserError.InvalidConfirmationHash
      ? t(m.Account.ConfirmEmailChange.ExpiredDescription)
      : t(m.ErrorMessage.Unknown);

  if (props.state === "pending") {
    return <SpinnerCenter />;
  }

  if (props.state === "error") {
    return (
      <InfoPage
        variant="warning"
        title={t(m.Account.ConfirmEmailChange.LinkExpired)}
        description={displayedError}
        primaryCTA={
          <>
            {props.isLoggedIn && (
              <>
                <Button onClick={props.requestNewChange}>
                  {t(m.Account.ConfirmEmailChange.RequestAnother)}
                </Button>
                <Button variant="grayscale" onClick={navigation.removeEmailChangeHashParamsFromUrl}>
                  {t(m.Account.ConfirmEmailChange.BackToAccount)}
                </Button>
              </>
            )}
            {!props.isLoggedIn && (
              <Button onClick={navigation.removeEmailChangeHashParamsFromUrl}>
                {t(m.Account.ConfirmEmailChange.SignInToRequest)}
              </Button>
            )}
          </>
        }
      />
    );
  }

  const buttonText = props.isLoggedIn
    ? t(m.Account.ConfirmEmailChange.BackToAccount)
    : t(m.Account.ConfirmEmailChange.BackToLogin);

  return (
    <InfoPage
      variant="success"
      title={t(m.Account.ConfirmEmailChange.Success)}
      description={t(m.Account.ConfirmEmailChange.SuccessDescription, { newEmail: props.newEmail })}
      primaryCTA={
        <Button onClick={navigation.removeEmailChangeHashParamsFromUrl}>{buttonText}</Button>
      }
    />
  );
};

export default ConfirmEmailChange;
